export function getBetAggr(scomSogei, handicap) {
	let market = window.xs_ag.betById[`${scomSogei}_${handicap}`];
	if (handicap != 0 && !market) {
		market = window.xs_ag.betById[`${scomSogei}_0`];
	}
	return market;
}
